import React, { createContext, useContext, useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import SearchBooking from '../../components/modules/booking-management/step1/searchBooking';
import Booking from '../../components/modules/booking-management/step2/booking';
import Payment from '../../components/modules/booking-management/step3/payment';
import { IModuleBookingManagementContextValue, ISearchForm } from '../../interfaces/bookingManagementContext';
import { AppContext } from '../../utils/appContext';
import { IOrder } from '../../interfaces/bookingContext';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export const ModuleBookingManagementContext = createContext<any>({});

const ModuleBookingManagement = () => {
  const appContext = useContext(AppContext);
  const [searchForm, setSearchForm] = useState<ISearchForm>({
    GuestNum: null,
    GuestArrival: null,
    GuestDeparture: null,
    property: null,
    status: 'to_start'
  });
  const [orders, setOrders] = useState<IOrder[]>([]);

  useEffect(() => {
    if (appContext.website) {
      setSearchForm({ ...searchForm, property: appContext.website });
    }
  }, []);

  const ModuleBookingManagementContextValue: IModuleBookingManagementContextValue = {
    searchForm,
    setSearchForm,
    orders,
    setOrders
  };

  return (
    <ModuleBookingManagementContext.Provider value={ModuleBookingManagementContextValue}>
      <LocalizationProvider adapterLocale={appContext.language} dateAdapter={AdapterDayjs}>
        <Switch>
          <Route exact path="/booking-management" component={SearchBooking} />
          <Route exact path="/booking-management/search" component={Booking} />
          <Route exact path="/booking-management/payment" component={Payment} />
        </Switch>
      </LocalizationProvider>
    </ModuleBookingManagementContext.Provider>
  );
};

export default ModuleBookingManagement;
